import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "uploadPicture"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-upload"
}, null, -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode("将视频拖到此处，或"), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1);

const _hoisted_4 = {
  class: "el-upload__tip"
};
const _hoisted_5 = {
  class: "videoItem"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
import $ from "@util/base";
import { ref, watch } from "vue";
import draggable from "vuedraggable";
import { UPLOAD_URL } from "@net/url";
import auth from "@net/auth";
import msg from "@ui/message";
import { ReadBase64Dimension } from "@util/image-dimension";
export default {
  __name: 'UploadVideo',
  props: {
    // 上传地址
    url: {
      type: String,
      default: UPLOAD_URL
    },
    // 上传个数
    limit: {
      type: Number,
      default: 1
    },
    fileSize: {
      type: Number,
      default: null
    },
    // 上传文件字段名
    name: {
      type: String,
      default: "file_data"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const idName = "video-" + $.uuid8();
    const upload = ref(null);
    const pictures = ref(props.modelValue || []);
    const progressFlag = ref(false);
    const loadProgress = ref(0);
    watch(() => props.modelValue, val => {
      pictures.value = val || [];
    });
    const headers = {
      accessToken: auth.getToken()
    };

    function uploadProcess(event) {
      progressFlag.value = true;
      loadProgress.value = parseInt(event.percent);

      if (loadProgress.value >= 100) {
        loadProgress.value = 99;
      }
    }

    function checkUploadFile(rawFile) {
      return true; // if (process.env.NODE_ENV === "production" && (props.imgSize != null || props.fileSize != null)) {
      //   return new Promise((res, rej) => {
      //     loadFile(rawFile, fileBase64 => {
      //       if (props.fileSize != null && rawFile.size > props.fileSize) {
      //         msg.error("视频大小以超过" + fileSizeText(props.fileSize))
      //         rej()
      //         return
      //       }
      //       res()
      //     })
      //   })
      // } else {
      //   return true
      // }
    }

    function loadFile(file, callback) {
      var reader = new FileReader();

      reader.onload = function (e) {
        callback(e.target.result);
      };

      reader.readAsDataURL(file);
    }

    function fileSizeText(value) {
      return parseInt(value / 1024) + "M";
    }

    function previewIndex(e) {
      for (let index = 0; index < pictures.value.length; index++) {
        if (e === pictures.value[index]) {
          return index;
        }
      }

      return 0;
    }

    function uploadSuccess(response) {
      loadProgress.value = 100;
      setTimeout(() => {
        progressFlag.value = false;
      }, 1000);

      if (response.code === 0) {
        pictures.value.push(response.data.fileUrl);
        emit('update:modelValue', pictures.value);
      } else {
        let err = '';

        if ($.isNotEmpty(response.msg)) {
          err = "：" + response.msg;
        }

        msg.error("视频上传失败" + err);
      }
    }

    function uploadError() {
      msg.error("视频上传失败");
    }

    function removePictures(name) {
      pictures.value.remove(e => {
        return e == name;
      });
      emit('update:modelValue', pictures.value);
    }

    function sortEnd() {
      emit('update:modelValue', pictures.value);
    }

    function getPictures() {
      return pictures.value;
    }

    return (_ctx, _cache) => {
      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_progress = _resolveComponent("el-progress");

      const _component_Close = _resolveComponent("Close");

      const _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [!__props.disabled ? (_openBlock(), _createBlock(_component_el_upload, {
        key: 0,
        ref_key: "upload",
        ref: upload,
        action: __props.url,
        multiple: "",
        drag: "",
        accept: ".mp4,.wmv,.flv,.avi,.mkv",
        limit: 100,
        name: __props.name,
        "on-progress": uploadProcess,
        disabled: __props.limit <= pictures.value.length,
        "on-success": uploadSuccess,
        "on-error": uploadError,
        "show-file-list": false,
        "before-upload": checkUploadFile
      }, {
        tip: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createTextVNode("最多上传" + _toDisplayString(__props.limit) + "个视频 ", 1), _withDirectives(_createElementVNode("span", null, "，文件大小" + _toDisplayString(fileSizeText(__props.fileSize)) + "以内", 513), [[_vShow, __props.fileSize]])])]),
        default: _withCtx(() => [_hoisted_2, _hoisted_3]),
        _: 1
      }, 8, ["action", "name", "disabled"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_progress, {
        percentage: loadProgress.value
      }, null, 8, ["percentage"]), [[_vShow, progressFlag.value]]), _createVNode(_unref(draggable), {
        class: "videoGroup",
        modelValue: pictures.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => pictures.value = $event),
        "item-key": "index",
        onEnd: sortEnd,
        disabled: __props.disabled
      }, {
        item: _withCtx(({
          element
        }) => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("div", {
          class: "del",
          onClick: _withModifiers($event => removePictures(element), ["stop"])
        }, [_createVNode(_component_el_icon, {
          size: 17
        }, {
          default: _withCtx(() => [_createVNode(_component_Close)]),
          _: 1
        })], 8, _hoisted_6), [[_vShow, !__props.disabled]]), _createElementVNode("video", {
          src: element,
          width: "250",
          height: "250",
          controls: ""
        }, null, 8, _hoisted_7)])]),
        _: 1
      }, 8, ["modelValue", "disabled"])]);
    };
  }

};